import Vue from 'vue';

export default Vue.component('exportfailure-modal', {
    template:`
    <div class="modal-content">
        <form :action="exportUrl" method="get" novalidate="novalidate">
            <div class="block block-rounded block-transparent mb-0">
                <div class="block-header bg-gray-lighter">
                    <h3 class="block-title">{{ resources.title }}</h3>
                </div>
                <div class="block-content">
                    <p>{{ resources.message }}</p>
                </div>
                <div class="block-content block-content-full text-right border-top">
                    <button class="btn btn-sm btn-dual mr-1" type="button" @click="$emit('close')">{{ resources.close }}</button>
                    <button class="btn btn-sm btn-secondary" type="submit" :disabled="!canExport">{{ resources.downloadAnyway }}</button>
                </div>
            </div>
        </form>
    </div>
    `,
    props:{
        name: String,
        canExport: Boolean,
        exportUrl: { type: String, default: null },
        resources: Object
    }
});